import { MapContainer, ZoomControl, useMapEvent } from 'react-leaflet'
import Layers from './Layers'
import "leaflet/dist/leaflet.css"
import "./Map.css"
import React, { useState, useCallback, useEffect, useReducer, useRef } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { Container, Table, Row, Col, ToggleButton, Stack, Button, Modal, Badge } from 'react-bootstrap';
import styled from 'styled-components';
import jsonCarInfoData from "../data/carinfo.json"
import { useAppContext } from "../libs/contextLib";
import axiosInstance from "../axiosApi";
import axios from 'axios'
import config from "../config";
import { onError } from "../libs/errorLib";
import { useTranslation } from 'react-i18next';
import DropdownSelector from "../components/DropdownSelector";
import LoadingSpinner from "../components/LoadingSpinner";
import ToggleSwitch from "../components/ToggleSwitch";

const deg2rad = (deg) => deg * (Math.PI / 180);

const getDistanceFromLatLonInMeters = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c * 1000;
};

function FlyMapTo({ flyToPosition, map, isPopStationInfo, routeMap, inStation, inFlag, getFlag,
                    setInFlag, setInStation, setGetFlag, setModalShow, setStationName,
                    setRouteStops, carAppContext }) {
  useEffect(() => {
    if (flyToPosition.lat === 0) return;
    map.flyTo(flyToPosition, 17);
    if (!isPopStationInfo) return;
    let distanceData = 100;
    routeMap.forEach((data) => {
      distanceData = getDistanceFromLatLonInMeters(
        flyToPosition.lat, flyToPosition.lng,
        Number(data.station.site_lat), Number(data.station.site_lng)
      );
      if (distanceData <= 50) {
        setInFlag(true);
        setInStation(Number(data.station.id));
      }
      if (distanceData > 50 && inStation === Number(data.station.id)) {
        setInFlag(false);
        setGetFlag(false);
        setModalShow(false);
      }
      if (inFlag && !getFlag && inStation === Number(data.station.id)) {
        setStationName(data.station.stationname);
        axiosInstance.get('/adrt/routestops/', {
          params: {
            routemap_id: data.id, route_id: data.route.id,
            routesection_id: data.routesection.id, station_id: data.station.id,
            vehicle_id: carAppContext.vehicle_id
          }
        }).then((response) => {
          setGetFlag(true);
          setRouteStops(response.data);
          setModalShow(true);
        }).catch(() => {});
      }
    });
  }, [flyToPosition]);
  return null;
}

const StyledModal = styled(Modal)`
  .modal-content {
    background-color: #E2E4F6;
    border-radius: 50px;
  }
`;

const StyledTable = styled(Table)`
  /* 여기에 원하는 스타일을 추가하세요 */
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  th, td {
    border-bottom: 1px solid #444444;
    padding: 5px;
    text-align: center;
  }
`;

function MyVerticallyCenteredModal(props) {
  const reservations = [
    { id: 1, booker: '2578', route: 'A노선경유지-3', seatnumber: '1', due: 'Now' },
    { id: 2, booker: '2645', route: 'A노선종착지', seatnumber: '2', due: '2024-05-05 15:45' },
    // 다른 예약 정보 추가
  ];

  return (
    <StyledModal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          예약정보
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>정류장 : {props.stationName}</h5>
        <StyledTable striped bordered hover variant="dark">
          <thead>
            <tr>
              <th>예약자</th>
              <th>좌석번호</th>
              <th>경로</th>
              <th>탑승예정</th>
            </tr>
          </thead>
          <tbody>
            {props.routeStops.result === "NOK" ?
              reservations.map((data) => (
                <tr key={data.id}>
                  <td>{data.booker}</td>
                  <td>{data.seatnumber}</td>
                  <td>{data.route}</td>
                  <td>{data.due}</td>
                </tr>
              ))
              :
              <tr key="1">
                <td colSpan={4}>{props.routeStops.message}</td>
              </tr>
            }
          </tbody>
        </StyledTable>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </StyledModal>
  );
}


const carInfoReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_OR_UPDATE':
      const newVehicle = action.payload;
      const existingIndex = state.findIndex(
        (vehicle) => vehicle.vehicle_id === newVehicle.vehicle_id
      );

      if (existingIndex !== -1) {
        // 기존 데이터 업데이트
        const updatedState = [...state];
        updatedState[existingIndex] = {
          ...updatedState[existingIndex],
          ...newVehicle
        };
        return updatedState;
      } else {
        // 새로운 데이터 추가
        return [...state, newVehicle];
      }
    case 'REMOVE':
      return state.filter(
        (vehicle) => vehicle.vehicle_id !== action.payload.vehicle_id
      );
    case 'CLEAR_ALL':
      return [];
    case 'SET_ALL': {
      return action.payload;
    }
    default:
      return state;
  }
};

const MapLeaflet = () => {
  const { t } = useTranslation();
  const [map, setMap] = useState(null);
  //Public API that will echo messages sent to it back to the client
  const [socketUrl] = useState(`${config.SOCKET_URL}/ws`);
  const [carInfo, dispatcher] = useReducer(carInfoReducer, []);
  const [carInfoLast, setCarInfoLast] = useState(jsonCarInfoData);
  const [onVehicleId, setOnVehicleId] = useState("");
  const {
    routeAppContext, setRouteAppContext,
    carAppContext, setCarAppContext,
    isAuthenticated,
    setCurrentLocation,
  } = useAppContext();
  const [carOptions, setCarOptions] = useState([]);
  const [routeMap, setRouteMap] = useState([]);
  const [carList, setCarList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [routeOptions, setRouteOptions] = useState([]);
  const [position, setPosition] = useState({
    lat: 35.69386,
    lng: 128.45977,
  });
  const [flyToPosition, setFlyToPosition] = useState({
    lat: 35.69386,
    lng: 128.45977,
  });
  const [isSwitchFlyToMap, setIsSwitchFlyToMap] = useState(false);
  const [isPopStationInfo, setIsPopStationInfo] = useState(false);
  const [isPopVideoInfo, setIsPopVideoInfo] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [routeStops, setRouteStops] = useState("");
  const [stationName, setStationName] = useState("");
  const [inFlag, setInFlag] = useState(false);
  const [getFlag, setGetFlag] = useState(false);
  const [inStation, setInStation] = useState(0);
  const [routeId, setRouteId] = useState("1");
  const messageQueueRef = useRef([]);
  const isProcessingRef = useRef(false);

  useEffect(() => { setCurrentLocation('/drivingcontrol'); }, []);

  const onSwitchFlyToMap = () => {
    setIsSwitchFlyToMap(!isSwitchFlyToMap);
    //console.log(isSwitchOnService);
  };

  const onSwitchPopStationInfo = () => {
    setIsPopStationInfo(!isPopStationInfo);
    //console.log(isSwitchOnService);
  };

  const addCarInfoHandler = useCallback((carInfo) => {
    dispatcher({ type: 'ADD_OR_UPDATE', payload: carInfo });
  }, []);

  const clearCarInfoHandler = useCallback(() => {
    dispatcher({ type: 'CLEAR_ALL' });
  }, []);

  const {
    sendJsonMessage,
    lastMessage,
    readyState,
  } = useWebSocket(socketUrl, {
    onOpen: () => {
      console.log('opened');
    },
    shouldReconnect: () => true,
  });

  const processQueue = useCallback(async () => {
    if (isProcessingRef.current || messageQueueRef.current.length === 0) {
      return;
    }

    isProcessingRef.current = true;

    while (messageQueueRef.current.length > 0) {
      const message = messageQueueRef.current.shift();

      try {
        const jsonLastMessage = JSON.parse(message);
        if (isAuthenticated && routeAppContext.id === jsonLastMessage.data.route_id) {
          addCarInfoHandler(jsonLastMessage.data);
          setCarInfoLast(jsonLastMessage);
          setOnVehicleId(jsonLastMessage.data.vehicle_id);
          if (jsonLastMessage.data.vehicle_id === carAppContext.vehicle_id) {
            if (!jsonLastMessage.control) {
              const controlData = {};
              controlData.route_id = jsonLastMessage.data.route_id;
              controlData.vehicle_id = jsonLastMessage.data.vehicle_id;
              controlData.ome_webrtc = isPopVideoInfo ? "PLAY" : "STOP";
              jsonLastMessage.control = controlData;
            } else {
              jsonLastMessage.control.ome_webrtc = isPopVideoInfo ? "PLAY" : "STOP";
            }
            setFlyToPosition({ lat: Number(jsonLastMessage.data.latitude), lng: Number(jsonLastMessage.data.longitude) });
          }
        }
      } catch (error) {
        console.error('메시지 처리 오류:', error);
      }
    }

    isProcessingRef.current = false;
  }, [isAuthenticated, routeAppContext, carAppContext, isPopVideoInfo]);

  useEffect(() => {
    if (lastMessage !== null) {
      if (JSON.parse(lastMessage.data).type !== 'robotaxi') {
        //setMessageHistory((prev) => prev.concat(lastMessage));
      } else {
        messageQueueRef.current.push(lastMessage.data);
        processQueue();
      }
    }
  }, [lastMessage, processQueue]);

  useEffect(() => {
    if (map && position.lat !== 0) {
      map.flyTo(position, map._zoom);
    }
  }, [position, map]);

  useEffect(() => {
    setRouteId(routeAppContext.id);
    setIsLoading(true);
    onLoad();
  }, []);

  useEffect(() => {
    if (readyState === ReadyState.OPEN && carList.length > 0) {
      console.log("WebSocket is open and carList is available.");
      carList.forEach((data) => {
        if (onVehicleId === data.vehicle_id) {
          console.log("현재 탑승 차량과 동일 차량입니다.: " + data.vehicle_id);
          console.log("현재 탑승 차량과 동일 차량입니다.: " + onVehicleId);
        }
      });
    }
  }, [readyState, carList]);

  async function onLoad() {
    console.log('MapLeaflet onLoad');
    try {
      setIsLoading(true);
      setCarOptions([]);
      setCarList([]);
      //console.log(localStorage.getItem('access_token'));
      axios.get(`${config.DJANGO_URL}/robotaxi/route/`).then(function (response) {
        //console.log(response.data);
        setRouteOptions(response.data.map(data => ({ name: data.routename, id: data.id, route: data })));

        setPosition({ lat: Number(routeAppContext.ref_lat), lng: Number(routeAppContext.ref_lng) });
        setFlyToPosition({ lat: Number(routeAppContext.ref_lat), lng: Number(routeAppContext.ref_lng) });
        axios.get(`${config.DJANGO_URL}/robotaxi/routemap/`, {
          params: { id: routeAppContext.id }
        }).then(function (response) {
          setRouteMap(response.data);
        }).catch(function (error) {
          console.log(error);
        });
        axios.get(`${config.DJANGO_URL}/robotaxi/robocar/`, {
          params: { route_id: routeAppContext.id }
        }).then(function (response) {
          clearCarInfoHandler();

          setCarList(response.data);
          setCarAppContext(response.data[0]);
          response.data.forEach((data) => {
            setCarOptions(carOptions => [...carOptions, { name: data.carname, id: data.id, car: data }]);
          });
        }).catch(function (error) {
          console.log(error);
        });

        setIsLoading(false);
      }).catch(function (error) {
        setIsLoading(false);
        onError(error);
      });
    } catch (error) {
      onError(error);
    }
  }

  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const handleClickSendMessage = async () => {
    for (let i = 0; i < 2; i++) {
        jsonCarInfoData.type = "robotaxi"
        jsonCarInfoData.data.route_id = routeAppContext.id;
        jsonCarInfoData.data.vehicle_id = carAppContext.vehicle_id;
        jsonCarInfoData.data.speed = Math.floor(Math.random() * 100);
        jsonCarInfoData.data.latitude = Number(routeMap[i].station.site_lat);
        jsonCarInfoData.data.longitude = Number(routeMap[i].station.site_lng);
        sendJsonMessage(jsonCarInfoData)
      await sleep(3000);
    }
  }

  function onChangeRoute(event) {
    const result = routeOptions.find(option => Number(option.id) === Number(event.target.value));
    if (result) {
      setRouteAppContext(result.route);
      setRouteId(result.route.id);
      setPosition({ lat: Number(result.route.ref_lat), lng: Number(result.route.ref_lng) });
      setFlyToPosition({ lat: Number(result.route.ref_lat), lng: Number(result.route.ref_lng) });
      setOnVehicleId('');
      axiosInstance.get('/robotaxi/routemap/', {
        params: { id: result.route.id }
      }).then(function (response) {
        setRouteMap(response.data);
      }).catch(function (error) {
        console.log(error);
      });

      axiosInstance.get('/robotaxi/robocar/', {
        params: { route_id: result.route.id }
      }).then(function (response) {
        setCarList(response.data);
        setCarAppContext(response.data[0]);
        response.data.forEach((data) => {
          setCarOptions(carOptions => [...carOptions, { name: data.carname, id: data.id, car: data }]);
        });
      }).catch(function (error) {
        console.log(error);
      });

      //initialize carinfo
      addCarInfoHandler(jsonCarInfoData.data);
    }
  };


  const handleZoomEnd = () => {
    //console.log('Map zoom level:');
  };

  function onSelectCar(event) {
    const result = carOptions.find(option => Number(option.id) === Number(event.currentTarget.id));
    setCarAppContext(result.car);
    setIsPopVideoInfo(false);
  }

  return (
    <Stack gap={1}>
      <div className="bg-light border">
        <Container fluid>
          <Row>
            <Col xs={12} md={4}>
              <DropdownSelector
                labelName={t('FMS_ROUTE')}
                options={routeOptions}
                defaultValue={routeId}
                onChange={onChangeRoute}
              />
            </Col>
            {isAuthenticated ?
              <>
                <Col xs={12} md="auto">
                  <ToggleSwitch label={t('FMS_CARVIEW')} isChecked={isSwitchFlyToMap} onChange={onSwitchFlyToMap} />
                </Col>
                {/*
                <Col xs={12} md="auto">
                  <ToggleSwitch label={t('FMS_CARVIDEO')} isChecked={isPopVideoInfo} onChange={onSwitchPopVideoInfo}/>
                </Col>
                */}
                <Col xs={12} md="auto">
                  <ToggleSwitch label={t('FMS_INFOVIEW')} isChecked={isPopStationInfo} onChange={onSwitchPopStationInfo} />
                </Col>
                <Col xs={12} md="auto" style={{ textAlign: 'center', }}>
                  <Button
                    onClick={handleClickSendMessage}
                    disabled={readyState !== ReadyState.OPEN}
                    size="sm"
                  >
                    {t('FMS_SENDLOCATION')}
                  </Button>
                </Col>
              </> : <Col></Col>}
          </Row>
        </Container>
      </div>
      <div className="bg-light border">
        <Container fluid>
          <Row>
            <Stack direction="horizontal" gap={2}>
              <Button variant="light" disabled>{t('FMS_INFOCAR')}</Button>
              {carList && carList.map((data) => {
                return (
                  <ToggleButton
                    id={data.id}
                    key={data.id}
                    type="checkbox"
                    variant="outline-primary"
                    value={data.vehicle_id}
                    checked={data.id === carAppContext.id}
                    onChange={(e) => onSelectCar(e)}
                  >
                    <b>{data.carname}</b>
                    {(onVehicleId === data.vehicle_id) ? (
                      <Badge bg="success" className="ms-2">ON</Badge>
                    ) : (
                      <Badge bg="danger" className="ms-2">OFF</Badge>
                    )
                    }
                  </ToggleButton>

                );
              })}
            </Stack>
          </Row>
        </Container>
      </div>
      <div className="bg-light border">
        {isLoading ? <LoadingSpinner /> : ""}
        <MapContainer
          center={{
            lat: Number(routeAppContext.ref_lat),
            lng: Number(routeAppContext.ref_lng),
          }}
          zoom={Number(routeAppContext.defalt_zoom)}
          style={{ height: '85vh', width: '100%' }}
          ref={setMap}
          zoomControl={false}
          scrollWheelZoom={true}
        >
          <Layers routeMap={routeMap} carInfo={carInfo} carInfoLast={carInfoLast} map={map} isPopVideoInfo={isPopVideoInfo} />
          <ZoomControl position='topright' />
          <ZoomEventHandlers handleZoomEnd={handleZoomEnd} />
          {isSwitchFlyToMap && (
            <FlyMapTo
              flyToPosition={flyToPosition}
              map={map}
              isPopStationInfo={isPopStationInfo}
              routeMap={routeMap}
              inStation={inStation}
              inFlag={inFlag}
              getFlag={getFlag}
              setInFlag={setInFlag}
              setInStation={setInStation}
              setGetFlag={setGetFlag}
              setModalShow={setModalShow}
              setStationName={setStationName}
              setRouteStops={setRouteStops}
              carAppContext={carAppContext}
            />
          )}
        </MapContainer>
      </div>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        stationName={stationName}
        routeStops={routeStops}
      />
    </Stack>
  )
}

const ZoomEventHandlers = ({ handleZoomEnd }) => {
  useMapEvent('zoomend', handleZoomEnd);
  return null;
};

export default MapLeaflet